import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  cellContent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    cursor: 'pointer',
    minWidth: 0
  },
  emailText: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: theme.colors.dark[9],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  serverText: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.colors.gray[6],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  moreIndicator: {
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    top: '50%',
    right: -40,
    fontSize: '12px',
    padding: '4px',
    backgroundColor: '#E7F5FF',
    borderRadius: '4px',
    fontWeight: 500,
    lineHeight: '16px',
    color: '#339AF0'
  },
  tooltip: {
    backgroundColor: 'rgba(52, 58, 64, 0.8)',
    padding: '12px',
    maxWidth: '320px',
    borderRadius: '8px'
  },
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  serverBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
  },
  serverName: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    color: theme.white,
    marginBottom: '4px'
  },
  emailItem: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.colors.gray[4],
    paddingLeft: '8px'
  }
}));
